import { Stack } from '@mui/material'
import dayjs from 'dayjs'
import React, { useContext, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { AuthContext } from '../../providers'
import { useGetAppointmentsForVehicleQuery } from '../../redux/api'
import { loggingAssert } from '../../utils/handleError/loggingAssert'
import { localDateTimeArrayToDate } from '../../utils/localDateTimeArraytoDate/localDateTimeArrayToDate'
import { AppointmentPanel } from '../AppointmentPanel'

export const AppointmentByVehicle = () => {
  const { id: vehicleId } = useParams()
  const { currentUser, userShopId } = useContext(AuthContext)
  const accessToken = loggingAssert(
    'No access token found where one was expected',
    currentUser?.accessToken
  )
  const shopId = loggingAssert(
    'No shop ID found where one was expected',
    userShopId
  )
  const { data: appointments } = useGetAppointmentsForVehicleQuery({
    authorization: accessToken,
    shop: shopId,
    vehicle: vehicleId!
  })

  const recentAppointments = useMemo(() => {
    const aWeekAgo = dayjs(new Date()).subtract(7, 'day')
    return (appointments || []).filter(
      (appointment) =>
        dayjs(localDateTimeArrayToDate(appointment.info!.startDateTime)).diff(
          aWeekAgo
        ) > 0
    )
  }, [appointments])

  return (
    <Stack spacing={2} aria-label="appointmentContainer">
      {recentAppointments.map((appointment, index) => (
        <AppointmentPanel appointment={appointment} key={index} />
      ))}
    </Stack>
  )
}
